import { AdminInfoCard } from "@/components/admin";

const InfoCard = () => {
  return (
    <AdminInfoCard
      title="위치 관리 기준"
      description="최신 위치 로그를 기준으로 표시합니다. 24시간 이상 새 위치가 없거나 권한/위치 제공자 상태가 정상값이 아니면 확인 대상으로 분류합니다."
    />
  );
};

export default InfoCard;
